/* ADD GROUPS */
export const ADD_QUIZZ = "ADD_QUIZZ"
export const ADD_QUIZZ_SUCCESS = "ADD_QUIZZ_SUCCESS"
export const ADD_QUIZZ_CLEAN = "ADD_QUIZZ_CLEAN"
export const ADD_QUIZZ_ERROR = "ADD_QUIZZ_ERROR"
